import React from "react";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

const Distribution = () => {
  const { brandData } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName;
  const productName = brandData?.logo?.productName;
  return (
    <div className="">
      {/* Freshness Delivered Section */}
      <div className="wrapper2">
        <h2 className="heading2">Freshness Delivered with Precision</h2>
      </div>

      <section className="py-0">
        <div className="container py-0">
          {/* more blogs */}
          <div className="row g-3">
            <div className="col-lg-4 col-12">
                <div className="product-item col">
                  <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                    <img
                      src="img/distribution-banner-min.png"
                      alt=""
                      className="card-img-top"
                    />
                    <div className="position-absolute text-overlay text-white p-3">
                      <h1
                        className="fw-bold opacity-50"
                        style={{ fontSize: "4rem" }}
                      >
                        05
                      </h1>
                    </div>
                  </div>
                </div>

              <p className="card-text text-muted py-3 px-2">
                At {brandName}, we take pride in ensuring that every{" "}
                {productName} reaches its destination fresh, safe, and of the
                highest quality. Our carefully designed distribution network
                combines cutting-edge technology with rigorous quality assurance
                processes. By maintaining optimal conditions during transit, we
                ensure that the superior standards of our products are never
                compromised.
              </p>
              <div className="underline2"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Distribution Insights Section */}
      <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Distribution Insights</h6>

          {/* Cards Grid */}
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/d1-min.png" alt="" className="card-img-top" />
                <div className="position-absolute text-overlay-f text-white p-3">
                  <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                    {" "}
                    <br />
                    Temperature Controlled Delivery
                  </h6>
                </div>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/d2-min.png" alt="" className="card-img-top" />
                <div className="position-absolute text-overlay-f text-white p-3">
                  <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                    <br />
                    Smart Routing & Tracking
                  </h6>
                </div>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/d3-min.png" alt="" className="card-img-top" />
                <div className="position-absolute text-overlay-f text-white p-3">
                  <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                    {" "}
                    <br />
                    Quality Checks Before Dispatch
                  </h6>
                </div>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/d4-min.png" alt="" className="card-img-top" />
                <div
                  className="position-absolute text-overlay-f text-white p-3"
                  style={{ top: "30%" }}
                >
                  <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                    <br />
                    <br />
                    Eco-Conscious Transportation
                  </h6>
                </div>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/d5-min.png" alt="" className="card-img-top" />
                <div
                  className="position-absolute text-overlay-f text-white p-3"
                  style={{ top: "30%" }}
                >
                  <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                    <br />
                    <br />
                    End-to-End Traceability
                  </h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/smart-manufacturing"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/it-is-you"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <Index /> */}
    </div>
  );
};

export default Distribution;
